const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class QuickBuyMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    this.listeners.add(
      window,
      'resize',
      debounce(() => {
        this.setupCarousel()
      }, 500),
    )
  }

  setupCarousel () {
    if (
      window.BAO.MediaBreakpoints.isXsViewport ||
      this.els.slide.elements.length < 2
    ) { return }

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('quick-buy-media')) {
  customElements.define('quick-buy-media', QuickBuyMedia)
}
